module.exports = __webpack_public_path__ + "img/logo.31cab149.png";